import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;
export const DialogBox = styled.div`
  max-width: 600px;
  max-height: 640px;
  display: flex;
  flex-direction: column;
  background-color: ${ColorSF2.white};
  @media (max-height: 530px) {
    max-height: 310px;
  }
`;
export const HeaderBlock = styled.div`
  padding-left: 18px;
  height: 64px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  @media (max-height: 530px) {
    height: 30px;
    font-size: 13px;
  }
`;
export const CloseButton = styled.div`
  margin: 20px 18px 20px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-height: 530px) {
    margin: 0px;
  }
`;
export const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
  @media (max-height: 530px) {
    width: 16px;
    height: 16px;
  }
`;
export const CancelButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CancelButtonImage = styled.img`
  width: 8px;
  height: 8px;
`;
export const BodyBlock = styled.div`
  margin: 8px 8px 10px;
`;
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const ContentWrapper = styled.div`
  width: 100%;
  margin-top: 8px;
  background-color: ${ColorSF2.white};
  margin-bottom: 2px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const InputTitle = styled.div`
  width: 120px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.lightGray};
  font-size: 12px;
  font-weight: 600;
`;
export const Input = styled.input`
  width: 100%;
  height: 24px;
  margin-left: 8px;
  margin-right: 5px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const SubTitle = styled.div`
  width: 100%;
  height: 20px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;
export const RemoteActionWrapper = styled.div`
  margin-top: 10px;
  padding: 10px;
  background: ${ColorSF2.white}};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const RemoteMembersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const RemoteMember = styled.div`
  margin: 2px;
  width: 100px;
  height: 24px;
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.bgColor || ColorSF2.lightGray};
  border-radius: 10px;
  font-size: 12px;
`;
export const MemberName = styled.div`
  width: 70px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
`;

export const AllClearButton = styled(RemoteMember)`
  padding-left: 0px;
  background-color: unset;
  border: 1px solid ${ColorSF2.mediumGray};
  justify-content: center;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.white};
`;
export const TheadTr = styled.tr`
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  cursor: pointer;
  height: 27px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;
export const Tbody = styled.tbody`
  width: 100%;
  background-color: ${ColorSF2.white};
`;
export const TbodyTr = styled.tr`
  width: 100%;
  height: 32px;
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  display: flex;
  flex-direction: row;
  background-color: ${props =>
    props.checked ? ColorSF2.skyBlue : ColorSF2.white};
`;
export const ThCheckbox = styled.th`
  width: 35px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 24px;
  }
`;
export const TdCheckbox = styled.td`
  width: 35px;
  cursor: pointer;
  @media (max-width: 830px), (max-height: 530px) {
    width: 24px;
  }
`;
export const ThOperatorName = styled.th`
  overflow: hidden;
  padding-left: 10px;
  tex-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
`;
export const SortWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
export const TdOperatorName = styled.td`
  width: calc(100% - 40px);
  padding: 0px;
  padding-left: 6px;
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
`;
export const ScrolledBody = styled.div`
  width: 100%;
  height: 100%;
  min-height: 180px;
  max-height: 180px;
  overflow-x: hidden;
  overflow-y: auto;
`;
export const OperatorNameWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const OperatorName = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const ButtonWrapper = styled.div`
  margin-top: 8px;
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
